export const API_URL = process.env.REACT_APP_API_URL || "";
export const GMAPS_API_KEY = process.env.REACT_APP_GMAPS_KEY || "";
export const FCM_KEY = process.env.REACT_APP_FCM_CERTIFICATE_KEY || "";

export const authorizeUrl = "oauth2/:application/authorize";

export enum HTTP_ERRORS {
  "Not_Found" = 404,
  "Unauthorized" = 401,
}
